var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 112,
    viewBox: "0 0 121 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Programming-rafiki"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desk--inject-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.0751953,
    y: 51.7603,
    width: 120.053,
    height: 4.31629,
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    opacity: 0.3,
    x: 0.0751953,
    y: 51.7603,
    width: 32.1309,
    height: 4.31629,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M32.7208 56.0767H29.9258L31.3887 110.174H32.7208H34.053L35.5194 56.0767H32.7208Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    opacity: 0.3,
    d: "M31.3877 110.174H32.7198V57.238L29.9707 57.7408L31.3877 110.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M6.22671 56.0767H3.43164L4.89454 110.174H6.22671H7.55887L9.02177 56.0767H6.22671Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    opacity: 0.3,
    d: "M4.89413 110.174H6.22629V57.238L3.47363 57.7408L4.89413 110.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M113.977 56.0767H111.182L112.645 110.174H113.977H115.309L116.775 56.0767H113.977Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    opacity: 0.3,
    d: "M112.645 110.174H113.977V57.2379L111.228 57.7407L112.645 110.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M87.4826 56.0767H84.6875L86.1504 110.174H87.4826H88.8147L90.2776 56.0767H87.4826Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    opacity: 0.3,
    d: "M86.1533 110.174H87.4855V57.238L84.7363 57.7408L86.1533 110.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M57.0617 28.6528H28.5174C28.0475 28.6341 27.5971 28.8419 27.3057 29.2117C27.0142 29.5814 26.9169 30.0686 27.0439 30.5223L30.846 48.7046C31.0974 49.7612 32.0175 50.5227 33.1004 50.5706H61.6659C62.135 50.5889 62.5845 50.3816 62.8758 50.0127C63.1671 49.6439 63.265 49.1578 63.1394 48.7046L59.3338 30.5223C59.0819 29.4582 58.1523 28.6933 57.0617 28.6528Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M33.3497 49.5334C32.6194 49.484 32.0034 48.9696 31.8232 48.2587L28.0211 30.0764C27.9552 29.8327 28.0033 29.5722 28.1518 29.3683C28.3059 29.1936 28.5308 29.0986 28.7631 29.1098H57.3286C58.059 29.1592 58.6749 29.6735 58.8551 30.3845L62.6573 48.5667C62.7232 48.8104 62.6751 49.0709 62.5265 49.2749C62.3734 49.4508 62.1479 49.5462 61.9152 49.5334H33.3497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    opacity: 0.4,
    d: "M54.8971 48.0777L51.2929 30.8374C51.2519 30.6307 51.3048 30.4165 51.4373 30.2529C51.5698 30.0893 51.7681 29.9934 51.9784 29.9911H56.6145C56.9455 29.9936 57.2305 30.2262 57.3 30.5505L60.9042 47.7767C60.9452 47.9834 60.8923 48.1976 60.7598 48.3612C60.6273 48.5248 60.429 48.6207 60.2187 48.623H55.5826C55.2558 48.622 54.9723 48.3965 54.8971 48.0777Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M30.3967 31.4991L30.2412 30.752H35.9656L36.1211 31.4991H30.3967Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M33.0402 33.3547L32.8848 32.6075H42.9166L43.0756 33.3547H33.0402Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M33.5672 35.2068L33.4082 34.4597H44.6556L44.8111 35.2068H33.5672Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M34.0979 37.0623L33.9424 36.3152H42.9954L43.1544 37.0623H34.0979Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M32.1385 40.0684L31.9795 39.3213H35.6014L35.7569 40.0684H32.1385Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M34.7785 41.9207L34.623 41.1736H39.033L39.192 41.9207H34.7785Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M40.2469 41.9207L40.0879 41.1736H44.5013L44.6568 41.9207H40.2469Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M35.3088 43.7762L35.1533 43.0291H50.065L50.2205 43.7762H35.3088Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M35.8361 45.6275L35.6807 44.8804H47.0517L47.2072 45.6275H35.8361Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M70.3961 50.4607H32.8129C31.7882 50.4607 31.1239 51.0449 31.3394 51.7602H72.6506C72.4385 51.0449 71.4209 50.4607 70.3961 50.4607Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    opacity: 0.1,
    d: "M20.4635 24.0564L16.8557 6.82661C16.8158 6.62049 16.8693 6.4073 17.0017 6.24457C17.1341 6.08184 17.3317 5.98636 17.5412 5.98389H46.7286C47.0586 5.98608 47.3431 6.21684 47.4141 6.5398L51.0219 23.7554C51.0629 23.962 51.01 24.1762 50.8774 24.3398C50.7449 24.5034 50.5466 24.5994 50.3364 24.6016H21.149C20.8221 24.6006 20.5386 24.3751 20.4635 24.0564Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M30.8393 6.55008H24.712L24.5742 5.88794H30.7015L30.8393 6.55008Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    opacity: 0.4,
    d: "M29.8433 7.60635H27.3839L27.2461 6.94421H29.7055L29.8433 7.60635Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    opacity: 0.4,
    d: "M33.9356 7.60635H30.1476L30.0098 6.94421H33.7978L33.9356 7.60635Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    opacity: 0.4,
    d: "M35.585 8.65774H27.6027L27.4648 7.99561H35.4507L35.585 8.65774Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    opacity: 0.4,
    d: "M34.5725 9.71329H27.8234L27.6855 9.05115H34.4347L34.5725 9.71329Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    opacity: 0.4,
    d: "M39.0468 20.905H34.75L34.8878 21.5636H39.1846L39.0468 20.905Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M33.6909 19.4602H27.3976L27.2598 18.7981H33.5531L33.6909 19.4602Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    opacity: 0.4,
    d: "M36.2227 21.9564H30.3711L30.5089 22.6186H36.3605L36.2227 21.9564Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    opacity: 0.4,
    d: "M34.4472 20.905H30.1504L30.2882 21.5636H34.585L34.4472 20.905Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    opacity: 0.4,
    d: "M38.5253 19.8503H29.9316L30.0695 20.5125H38.6631L38.5253 19.8503Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M30.6225 1.63601H23.6896L23.5518 0.977417H30.4846L30.6225 1.63601Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    opacity: 0.4,
    d: "M34.0471 4.13574H26.4004L26.5382 4.79788H34.1813L34.0471 4.13574Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    opacity: 0.4,
    d: "M32.5174 3.08423H26.1816L26.3195 3.74283H32.6552L32.5174 3.08423Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    opacity: 0.4,
    d: "M32.9392 2.02881H25.9639L26.1017 2.69095H33.077L32.9392 2.02881Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M30.5475 11.4263H25.7277L25.5898 10.7642H30.4097L30.5475 11.4263Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    opacity: 0.4,
    d: "M38.1152 13.9226H28.6982L28.8361 14.5847H38.2495L38.1152 13.9226Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    opacity: 0.4,
    d: "M32.3776 12.8711H28.4766L28.6144 13.5332H32.5154L32.3776 12.8711Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    opacity: 0.4,
    d: "M36.613 12.8711H32.7119L32.8497 13.5332H36.7508L36.613 12.8711Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    opacity: 0.4,
    d: "M36.8525 11.8164H28.2588L28.3966 12.4785H36.9867L36.8525 11.8164Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    opacity: 0.4,
    d: "M36.8361 17.085H29.3555L29.4933 17.7436H36.9739L36.8361 17.085Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    opacity: 0.4,
    d: "M31.3115 16.0295H29.1348L29.2726 16.6917H31.4457L31.3115 16.0295Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    opacity: 0.4,
    d: "M34.7144 16.0295H31.6084L31.7462 16.6917H34.8522L34.7144 16.0295Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    opacity: 0.4,
    d: "M37.5097 14.978H28.916L29.0538 15.6366H37.6475L37.5097 14.978Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    opacity: 0.4,
    d: "M44.2771 14.8012H41.1993L41.0615 14.139H44.1428L44.2771 14.8012Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    opacity: 0.4,
    d: "M49.3984 14.8012H44.6564L44.5186 14.139H49.2606L49.3984 14.8012Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    opacity: 0.4,
    d: "M51.4136 15.8559H41.4171L41.2793 15.1937H51.2758L51.4136 15.8559Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    opacity: 0.4,
    d: "M50.0847 16.9081H41.6359L41.498 16.246H49.9468L50.0847 16.9081Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    opacity: 0.4,
    d: "M53.8694 10.6121H44.2969L44.4347 11.2707H54.0072L53.8694 10.6121Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    opacity: 0.4,
    d: "M52.012 9.55737H44.0791L44.2169 10.2195H52.1463L52.012 9.55737Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M50.5778 8.50513H41.8428L41.9806 9.16372H50.7156L50.5778 8.50513Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    opacity: 0.4,
    d: "M54.3017 21.1206H42.5137L42.6515 21.7827H54.4395L54.3017 21.1206Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    opacity: 0.4,
    d: "M47.1783 20.0701H42.2949L42.4327 20.7287H47.3161L47.1783 20.0701Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    opacity: 0.4,
    d: "M52.4781 20.0701H47.5947L47.7325 20.7287H52.6159L52.4781 20.0701Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    opacity: 0.4,
    d: "M52.8334 19.0145H42.0771L42.215 19.6767H52.9712L52.8334 19.0145Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    opacity: 0.4,
    d: "M52.5349 24.2798H43.1709L43.3087 24.9419H52.6727L52.5349 24.2798Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    opacity: 0.4,
    d: "M45.6765 23.2278H42.9521L43.09 23.8899H45.8144L45.6765 23.2278Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    opacity: 0.4,
    d: "M49.9387 23.2275H46.0518L46.1896 23.8897H50.0765L49.9387 23.2275Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    opacity: 0.4,
    d: "M53.4941 22.1729H42.7344L42.8722 22.835H53.6284L53.4941 22.1729Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    opacity: 0.4,
    d: "M24.8423 25.0977H17.5137L17.6515 25.7598H24.9801L24.8423 25.0977Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    opacity: 0.4,
    d: "M22.6766 24.0454H17.2949L17.4327 24.704H22.8108L22.6766 24.0454Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    opacity: 0.4,
    d: "M28.4318 24.0454H23.0537L23.1915 24.704H28.5732L28.4318 24.0454Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    opacity: 0.4,
    d: "M27.834 22.9907H17.0742L17.212 23.6529H27.9683L27.834 22.9907Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    d: "M110.127 44.8804H105.59L106.12 51.7602H109.597L110.127 44.8804Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    opacity: 0.4,
    d: "M110.127 44.8804H105.59L106.12 51.7602H109.597L110.127 44.8804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M11.2467 40.1042H17.7697L15.5435 51.7607H9.02051L11.2467 40.1042Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    d: "M19.5538 36.9808H10.3418L12.9213 51.7603H22.1334L19.5538 36.9808Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    d: "M9.79883 36.9807H10.343L12.9225 51.7602H12.3783L9.79883 36.9807Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    opacity: 0.3,
    d: "M9.79883 36.9807H10.343L12.9225 51.7602H12.3783L9.79883 36.9807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    d: "M14.249 50.1771L12.2207 38.5596H18.2349L20.2596 50.1771H14.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    opacity: 0.6,
    d: "M19.974 50.1771L17.9492 38.5596H18.2354L20.2602 50.1771H19.974Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    d: "M65.4831 18.3577C65.614 18.6419 65.5715 18.9439 65.3841 19.0292C65.1966 19.1145 64.9419 18.9546 64.8111 18.6739C64.6802 18.3932 64.7262 18.0877 64.9101 18.0024C65.094 17.9171 65.3522 18.0592 65.4831 18.3577Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    d: "M65.5948 18.9187C65.5948 18.9187 65.708 20.8587 65.3613 21.9814C66.0687 22.2195 66.8327 21.6261 66.8327 21.6261L65.5948 18.9187Z",
    fill: "#FF5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    d: "M65.5193 16.0086C65.4892 16.0335 65.4521 16.0484 65.4132 16.0512C64.9462 16.0636 64.5135 16.3001 64.2495 16.6872C64.2178 16.7467 64.1564 16.7842 64.0892 16.7849C64.0221 16.7856 63.9598 16.7495 63.9269 16.6907C63.894 16.6319 63.8956 16.5597 63.9311 16.5024C64.2563 16.0066 64.8011 15.7004 65.3919 15.6817C65.4713 15.6773 65.5444 15.7245 65.5734 15.7988C65.6023 15.8731 65.5805 15.9577 65.5193 16.0086Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    d: "M75.8985 17.9161C76.9915 21.7179 78.2117 24.6669 79.7008 26.351C79.7008 26.351 79.7291 29.3391 74.6605 30.7603C69.0862 32.3237 71.2225 28.728 71.2225 28.728C74.0522 27.1469 73.7834 24.7593 71.6541 23.8497L75.8985 17.9161Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    d: "M80.8833 25.6231C80.7843 24.2339 80.6534 22.6493 79.801 22.6066C78.8601 22.564 73.4131 25.0085 72.2494 26.7317C71.0857 28.4549 73.36 30.1426 73.36 30.1426L80.8833 25.6231Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    d: "M69.7336 47.1366L65.0293 46.9802L65.1142 50.9383C65.1142 50.9383 69.2172 50.5119 69.3975 49.4283L69.7336 47.1366Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    d: "M62.543 48.9242L62.0479 50.9494L65.1145 50.9423L65.0296 46.9843L62.543 48.9242Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M88.6171 30.6898L88.518 31.7059C88.4862 32.0328 88.4437 32.3526 88.4013 32.6759C88.3199 33.319 88.2174 33.9621 88.1077 34.6016C87.8955 35.8843 87.6196 37.1598 87.3013 38.4425C86.9777 39.7497 86.5857 41.0389 86.127 42.3046C85.8829 42.9548 85.6283 43.605 85.3241 44.2659C85.0174 44.9591 84.6629 45.6299 84.263 46.2733C84.1675 46.4403 84.0472 46.6286 83.9305 46.785C83.8137 46.9413 83.7006 47.1403 83.5768 47.3037C83.453 47.4671 83.3221 47.659 83.1594 47.826L82.9295 48.0889C82.8472 48.1859 82.7599 48.2784 82.6677 48.3661C81.9588 49.0635 81.1278 49.6236 80.2166 50.0182C78.8186 50.6206 77.3349 50.9983 75.82 51.1374C75.1303 51.2191 74.4477 51.2511 73.7792 51.2689C73.1107 51.2867 72.4422 51.2689 71.7843 51.2334C71.1264 51.1978 70.4756 51.141 69.8283 51.0628C69.181 50.9846 68.5514 50.8816 67.8652 50.743L67.9784 47.0301C70.2369 46.6334 72.4693 46.0995 74.6634 45.4313C75.1514 45.2719 75.6308 45.0869 76.0995 44.877C76.4985 44.7078 76.88 44.4996 77.2384 44.2552C77.4468 44.1291 77.6235 43.9565 77.7548 43.7507L77.8574 43.5872C77.9049 43.5174 77.9486 43.4451 77.9882 43.3705C78.0387 43.289 78.0847 43.2047 78.1262 43.1182C78.1722 43.0259 78.2217 42.9406 78.2677 42.8376C78.6832 41.9262 79.025 40.9828 79.2899 40.0164C79.5799 38.9719 79.8523 37.8846 80.0716 36.7583C80.2909 35.632 80.5031 34.495 80.6976 33.3474L80.9664 31.6206L81.2105 29.9401L88.6171 30.6898Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    opacity: 0.2,
    d: "M88.6171 30.6898L88.518 31.7059C88.4862 32.0328 88.4437 32.3526 88.4013 32.6759C88.3199 33.319 88.2174 33.9621 88.1077 34.6016C87.8955 35.8843 87.6196 37.1598 87.3013 38.4425C86.9777 39.7497 86.5857 41.0389 86.127 42.3046C85.8829 42.9548 85.6283 43.605 85.3241 44.2659C85.0174 44.9591 84.6629 45.6299 84.263 46.2733C84.1675 46.4403 84.0472 46.6286 83.9305 46.785C83.8137 46.9413 83.7006 47.1403 83.5768 47.3037C83.453 47.4671 83.3221 47.659 83.1594 47.826L82.9295 48.0889C82.8472 48.1859 82.7599 48.2784 82.6677 48.3661C81.9588 49.0635 81.1278 49.6236 80.2166 50.0182C78.8186 50.6206 77.3349 50.9983 75.82 51.1374C75.1303 51.2191 74.4477 51.2511 73.7792 51.2689C73.1107 51.2867 72.4422 51.2689 71.7843 51.2334C71.1264 51.1978 70.4756 51.141 69.8283 51.0628C69.181 50.9846 68.5514 50.8816 67.8652 50.743L67.9784 47.0301C70.2369 46.6334 72.4693 46.0995 74.6634 45.4313C75.1514 45.2719 75.6308 45.0869 76.0995 44.877C76.4985 44.7078 76.88 44.4996 77.2384 44.2552C77.4468 44.1291 77.6235 43.9565 77.7548 43.7507L77.8574 43.5872C77.9049 43.5174 77.9486 43.4451 77.9882 43.3705C78.0387 43.289 78.0847 43.2047 78.1262 43.1182C78.1722 43.0259 78.2217 42.9406 78.2677 42.8376C78.6832 41.9262 79.025 40.9828 79.2899 40.0164C79.5799 38.9719 79.8523 37.8846 80.0716 36.7583C80.2909 35.632 80.5031 34.495 80.6976 33.3474L80.9664 31.6206L81.2105 29.9401L88.6171 30.6898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    d: "M67.7305 35.412C69.4844 43.0077 70.4715 50.7617 70.6769 58.5564H91.3862C91.4994 55.9875 91.0679 41.5019 88.9846 31.0382C88.611 29.1235 87.4847 27.4411 85.8605 26.3712C84.2362 25.3013 82.2512 24.9343 80.3542 25.3533L80.2552 25.3782C77.6696 25.968 73.9592 26.9202 71.7663 27.7552L71.6779 27.7907C68.6441 28.9756 66.9552 32.2364 67.7305 35.412Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    opacity: 0.2,
    d: "M69.0762 42.0563C69.2389 43.0547 69.4051 44.1135 69.5572 45.2221C71.2515 43.4456 71.7891 38.0023 71.7891 38.0023L69.0762 42.0563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    d: "M51.872 47.3955L47.1713 46.955L47.0156 50.9095C48.5991 51.3486 50.2943 50.8681 51.4157 49.6624L51.872 47.3955Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    d: "M44.9384 48.1203L43.4316 50.8384L47.0323 50.9095L47.188 46.955L44.9384 48.1203Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    d: "M75.5 33.589C75.1746 34.2108 74.8845 34.7615 74.5591 35.33C74.2337 35.8985 73.9225 36.4528 73.5865 37.0035C72.9215 38.112 72.2318 39.1993 71.5031 40.2758C70.0403 42.4805 68.4196 44.5752 66.6539 46.5434C65.7083 47.603 64.6805 48.5855 63.5802 49.4817C63.4422 49.599 63.2795 49.7127 63.1274 49.837C62.9753 49.9614 62.8409 50.0609 62.6146 50.1923C62.3882 50.3238 62.1972 50.4553 61.992 50.569C61.7869 50.6827 61.5747 50.7857 61.366 50.8781C60.5858 51.2183 59.7693 51.4675 58.9325 51.6207C57.4689 51.8685 55.9773 51.902 54.5041 51.7201C53.8142 51.6407 53.1292 51.5221 52.4526 51.3648C52.1154 51.2867 51.783 51.1978 51.4552 51.0984C51.1015 50.9989 50.815 50.8887 50.4365 50.7431L51.0201 47.0763C53.2414 46.7743 55.643 46.387 57.2984 45.6338C57.6659 45.4821 58.0119 45.2826 58.3277 45.0404C58.4548 44.9526 58.5733 44.8526 58.6814 44.742C58.7061 44.71 58.8158 44.6141 58.8971 44.5359C58.9785 44.4577 59.074 44.3831 59.1624 44.2908C59.9195 43.5371 60.6283 42.7361 61.2846 41.8925C62.7086 40.0471 64.039 38.1308 65.2709 36.1508C65.9075 35.1453 66.5265 34.122 67.1455 33.0952L68.0581 31.5532L68.9388 30.036L75.5 33.589Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    d: "M69.8165 107.751H65.947L63.998 98.7445H67.8711L69.8165 107.751Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    d: "M65.7303 106.92H70.0808C70.2361 106.926 70.3695 107.032 70.4098 107.183L71.1738 110.644C71.2107 110.814 71.1678 110.992 71.0574 111.126C70.947 111.261 70.7813 111.337 70.6079 111.333C69.0905 111.308 68.3512 111.219 66.4377 111.219C65.2599 111.219 63.7495 111.34 62.126 111.34C60.5025 111.34 60.2868 109.727 60.9517 109.581C63.937 108.924 64.1351 108.022 65.1007 107.158C65.2738 107.003 65.4983 106.918 65.7303 106.92Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    d: "M67.8756 98.7488H63.999L65.0814 103.737L68.8801 103.393L67.8756 98.7488Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    d: "M74.6569 13.3474C76.0717 16.943 77.055 18.9789 76.1212 21.5904C74.7064 25.5165 69.6873 25.9144 67.2468 22.8091C65.0538 20.0129 63.1367 14.6016 65.9062 11.6277C67.1394 10.2872 68.976 9.68433 70.7592 10.0348C72.5424 10.3852 74.0175 11.6389 74.6569 13.3474Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    d: "M67.8617 18.7339C67.2817 19.5156 66.836 20.109 66.836 20.109C66.836 20.109 65.644 17.1351 66.1003 15.7707C65.5202 14.616 64.3495 16.3179 63.9073 14.0688C63.4652 11.8197 65.3787 9.40368 66.1003 8.90271C66.1747 9.16478 66.2081 9.43687 66.1993 9.70925C68.1491 8.11982 70.6271 7.3337 73.1319 7.50992C72.9226 7.82269 72.7893 8.1805 72.7429 8.55451C72.7429 8.55451 76.9413 9.26512 77.8963 11.6528C77.5586 11.4908 77.2021 11.3715 76.8352 11.2974C77.6049 12.4059 77.9098 13.774 77.6841 15.1063C77.3795 17.0493 77.2211 19.0126 77.2101 20.9794C77.249 21.9885 74.4937 23.9178 72.8136 21.857C71.1335 19.7963 67.8617 18.7339 67.8617 18.7339Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    d: "M69.6096 17.9593C69.8287 18.7968 69.7665 19.6835 69.4327 20.4819C68.9835 21.5478 68.0604 21.292 67.6041 20.3611C67.1903 19.5262 66.925 17.9771 67.6571 17.2345C68.3893 16.4919 69.3337 16.9538 69.6096 17.9593Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    d: "M76.8808 58.5419C76.8808 58.5419 58.8984 65.0937 58.3714 73.7595C57.3952 89.7232 63.8927 102.361 63.8927 102.361L69.8491 101.722C69.8491 101.722 68.788 96.5841 67.9992 82.1233C67.0053 63.9496 97.7104 82.5497 91.3862 58.5419H76.8808Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    opacity: 0.5,
    d: "M76.8808 58.5419C76.8808 58.5419 58.8984 65.0937 58.3714 73.7595C57.3952 89.7232 63.8927 102.361 63.8927 102.361L69.8491 101.722C69.8491 101.722 68.788 96.5841 67.9992 82.1233C67.0053 63.9496 97.7104 82.5497 91.3862 58.5419H76.8808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    d: "M62.2467 100.159C62.2184 100.159 63.1946 102.816 63.1946 102.816L70.6224 102.084L70.251 99.6682L62.2467 100.159Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    d: "M53.0879 108.195H49.2149L48.083 99.1848H51.9561L53.0879 108.195Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    d: "M49.1876 106.917H53.4321C53.59 106.915 53.7275 107.025 53.761 107.18L54.5321 110.637C54.5778 110.809 54.5404 110.992 54.4311 111.132C54.3219 111.271 54.1536 111.351 53.9768 111.348C52.4523 111.323 50.2452 111.237 48.3175 111.241C46.0751 111.241 45.6471 111.365 43.012 111.369C41.4203 111.369 40.9782 109.759 41.6431 109.592C44.6708 108.924 45.64 108.85 48.2539 107.226C48.5298 107.036 48.8536 106.929 49.1876 106.917Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    opacity: 0.2,
    d: "M48.0898 99.1881L48.7053 104.095L52.5465 103.832L51.9629 99.1881H48.0898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    d: "M70.6751 58.5419C70.6751 58.5419 41.2116 61.1676 41.5299 76.0334C41.8588 91.4962 47.6101 101.924 47.6101 101.924H53.3613C53.3613 101.924 52.2719 93.9016 52.4664 78.6804C52.523 74.1219 61.6981 72.6154 70.6539 72.0825C78.3929 71.6206 85.6368 67.1899 88.6433 60.0022L89.2623 58.5419H70.6751Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    opacity: 0.5,
    d: "M70.6751 58.5419C70.6751 58.5419 41.2116 61.1676 41.5299 76.0334C41.8588 91.4962 47.6101 101.924 47.6101 101.924H53.3613C53.3613 101.924 52.2719 93.9016 52.4664 78.6804C52.523 74.1219 61.6981 72.6154 70.6539 72.0825C78.3929 71.6206 85.6368 67.1899 88.6433 60.0022L89.2623 58.5419H70.6751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    d: "M46.2602 100.372C46.2355 100.372 47.247 103.043 47.247 103.043L54.1938 102.542L53.787 100.126L46.2602 100.372Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    d: "M78.411 41.8358L74.6724 56.3073C73.7164 60.0148 73.2339 63.8293 73.2363 67.6592V74.3851C73.2363 76.0834 74.4814 77.462 76.02 77.462H95.1837C96.7223 77.462 97.9673 76.0834 97.9673 74.3851V67.6592C97.9661 63.8292 98.4498 60.0146 99.4069 56.3073L102.707 43.5164C103.216 41.5515 101.879 39.608 100.029 39.608H81.085C79.7914 39.6489 78.6903 40.5663 78.411 41.8358Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    d: "M54.5744 70.4549L55.2004 74.0435C55.5329 75.9301 57.1847 77.4615 58.8931 77.4615H80.1967C81.9051 77.4615 83.0263 75.9301 82.6939 74.0435L82.0678 70.4549C81.6893 68.3053 79.8112 66.5643 77.8658 66.5643H57.4288C55.4693 66.5643 54.1995 68.3053 54.5744 70.4549Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    d: "M82.2458 81.0648H71.0865L69.9971 77.462H83.3352L82.2458 81.0648Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 74.6748,
    y: 81.0647,
    width: 3.98624,
    height: 26.7934,
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    opacity: 0.7,
    d: "M78.661 107.858H74.6748V81.7076L78.661 82.1162V107.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    opacity: 0.7,
    d: "M77.6868 107.858H76.7354V81.9176L77.6868 82.0171V107.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    d: "M85.8329 112.001H67.4969C67.2777 111.999 67.0843 111.857 67.0169 111.647C66.9495 111.437 67.0232 111.208 67.1998 111.078L70.1072 108.946C71.505 107.917 73.1922 107.362 74.9247 107.361H78.4087C80.14 107.363 81.8259 107.918 83.2226 108.946L86.1336 111.078C86.3107 111.208 86.3842 111.439 86.3159 111.649C86.2476 111.859 86.0528 112.001 85.8329 112.001Z",
    fill: "#407BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.de247bf315100f670183d584c8d97c6b.svg";
export { ForwardRef as ReactComponent };